import React, {useContext, useEffect, useState} from "react";
import {Grid, Mui, AlertTypes, MainLoader} from "@leap4/frontend";
import {OrganizationContext} from "./OrganizationContex";
import {IOrganizationPartners, PublisherLoginsContainer} from './AddEditOrganization/PublisherLogins.container'
import {IOrganization} from "../interfaces/IOrganization";
import {setAlert} from "../../../actions/alert";
import {getAllOrganizations} from "../../../actions/users";
import {useDispatch} from "react-redux";
import {
    ForeingAccessContainer,
    IOrganizationPartnersForeingAccess
} from "./AddEditOrganization/ForeingAccess.container";
import {OwnershipDashboard} from "./ownerships/OwnershipDashbord";
import {ClientForm} from "./Client/ClientForm";

const {TextField, Typography} = Mui;



const DetailsForm = () => {
    const dispatch = useDispatch();
    const {organization, setOrganization} = useContext(OrganizationContext);

    const [allOrganizations, setAllOrganizations] = useState<IOrganization[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const updatePublisherLogins = (publisherLogins: IOrganizationPartners[]) => {
        let publisherLoginsForState = {}

        if (publisherLogins) {
            publisherLoginsForState = publisherLogins.reduce((acc: any, currVal) => {
                const organizationId: string = currVal.org._id
                acc[organizationId] = {
                    partners: currVal.selectedPartners,
                    toSkipDiscrepancy: currVal.toSkipDiscrepancy,
                    facadeName: currVal.facadeName
                };
                return acc;
            }, {})
        }

        setOrganization({
            ...organization,
            publisherLogin: publisherLoginsForState,
        })
    }

    const handleFormChange = (e: any) => {
        setOrganization({
            ...organization,
            name: e.target.value
        })
    }

    const updatePublisherLoginsForeingAccess = (foreingAccess: IOrganizationPartnersForeingAccess[]) => {
        let foreingAccessForState = {}

        if (foreingAccess) {
            foreingAccessForState = foreingAccess.reduce((acc: any, currVal) => {
                const organizationId: string = currVal.org._id
                acc[organizationId] = {
                    partners: currVal.selectedPartners,
                    toSkipDiscrepancy: currVal.toSkipDiscrepancy
                };
                return acc;
            }, {})
        }

        setOrganization({
            ...organization,
            foreingAccess: foreingAccessForState
        })
    }

    useEffect(() => {
        if (!organization._id) {
            setIsLoading(false)
            return;
        }
        let loadedOrganizations;
        (async () => {
            try {
                setIsLoading(true);
                loadedOrganizations = await getAllOrganizations(dispatch) as IOrganization[]
                setAllOrganizations(loadedOrganizations)
            } catch (err) {
                setAlert("Couldn't load organizations", AlertTypes.FAILURE)
            } finally {
                setIsLoading(false);
            }
        })()
    }, []);

    if (isLoading) {
        return <Grid item padding={0}>
            <MainLoader/>
        </Grid>
    }

    return (
        <>
            <Typography fontFamily={"Quicksand"} fontWeight={600} variant="h5">
                {organization._id ? "ORGANIZATION INFO" : "CREATE ORGANIZATION "}
            </Typography>

            {!organization._id ? (
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    label="Organization name"
                    name="Organization name"
                    type="string"
                    autoComplete="email"
                    value={organization.name}
                    autoFocus
                    onChange={handleFormChange}

                />
            ) : (
            <Grid container gap={"10px"}>
            {organization?.name && <Grid item lg={12} width={"100%"}>
                <TextField fullWidth label={"Organization"} disabled value={organization?.name}/>
            </Grid>}
                <Grid item width='100%'>
                </Grid>
            </Grid>
            )}
            {organization._id && (
                <Grid>
                    <ClientForm
                        organizationId={organization._id}
                        dispatch={dispatch}
                    />
                </Grid>
            )}
            {!organization._id ? (<>
            </>) : (
            <PublisherLoginsContainer allOrganizations={allOrganizations}
                                      updatePublisherLogins={updatePublisherLogins}
                                      currentOrganization={organization}
            />
            )}
            {!organization._id ? (<>
            </>) : (
            <ForeingAccessContainer allOrganizations={allOrganizations}
                                    updatePublisherLogins={updatePublisherLoginsForeingAccess}
                                    currentOrganization={organization}
            />
            )}
            {!organization._id ? (<>
            </>) : (
        <Grid>
            <OwnershipDashboard
                organization={organization}
            />
        </Grid>
                )}
        </>
    )
}

export {DetailsForm}


